import { createAsyncThunk } from "@reduxjs/toolkit";
import { appName } from "../../constants/defaultValues"

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  getCustomer,
  setCustomer,
} from "../../utils/helpers";

import {
  notification
} from "../actions";

export const createCustomer = createAsyncThunk("createCustomer", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.post(`/v1/users`, payload);
    if (response && response.data && response.data.success) {
      setCustomer(response.data.data.id)
      return response.data
    } else {
      return {}
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const updateCustomer = createAsyncThunk("updateCustomer", async (payload, thunkAPI) => {
  let userId = getCustomer();
  try {
    let response = await axiosChargebee.patch(`/v1/users/${userId}`, payload);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const createContact = createAsyncThunk("createContact", async (payload, thunkAPI) => {
  try {
    let response = await axiosHubspot.post(`/v1/create-contact`, payload);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `Contact Created`, message: `The contact has been created/updated with some errors.`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `Contact Created`, message: `The contact has been created/updated with some errors.`, type: `warning` }));
    console.log("Error:", e)
  }
})

export const updateContact = createAsyncThunk("updateContact", async (payload, thunkAPI) => {
  try {
    let response = await axiosHubspot.patch(`/v1/update-contact`, payload);
    if (response && response.data && response.data.success) {
      return response.data.data
    } else {
      thunkAPI.dispatch(notification({ title: `Contact Updated`, message: `The contact has been created/updated with some errors.`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `Contact Updated`, message: `The contact has been created/updated with some errors.`, type: `warning` }));
    console.log("Error:", e)
  }
})

export const getCountries = createAsyncThunk("getCountries", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.get(`/countries`, {
      tenantHost: "marquet"
    });
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const getStates = createAsyncThunk("getStates", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.get(`/states?country_id=${payload.countryId}&country_iso_code=${payload.isoCode}`, {
      tenantHost: "marquet"
    });
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const getCities = createAsyncThunk("getCities", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.get(`/cities?country_id=${payload.countryId}&state_id=${payload.stateId}&country_iso_code=${payload.countryCode}&state_iso_code=${payload.isoCode}`, {
      tenantHost: "marquet"
    });
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})